'use client'

import React from 'react'
import { NumericProps } from '@eo-locale/react'
import { useI18n } from './use-i18n'

type FormattedCurrencyProps = {
  amount: number
  opts?: NumericProps
}

export const FormattedCurrency = ({ amount, opts }: FormattedCurrencyProps) => {
  const { formatCurrency } = useI18n()

  return <span>{formatCurrency(amount, opts)}</span>
}
